import {
    CLIP_REQUEST_GET_USER_REQUEST,
    CLIP_REQUEST_GET_USER_RESULT
} from 'Redux/actionTypes';

export const clipRequestGetUserRequest = (data) => ({
    type: CLIP_REQUEST_GET_USER_REQUEST,
    payload: data
})

export const clipRequestGetUserResult = (data) => ({
    type: CLIP_REQUEST_GET_USER_RESULT,
    payload: data
})